// src/data/currencies.js
// Список валют, поддерживаемых приложением.
// Связь со странами — в countries.js (поле currency).
// Универсальные USD и EUR доступны для любой страны (можно выбрать вручную).

export const CURRENCIES = [
  // Центральная Азия
  { code: 'KGS', symbol: 'с',   name: 'Кыргызский сом' },
  { code: 'KZT', symbol: '₸',   name: 'Казахстанский тенге' },
  { code: 'UZS', symbol: 'сўм', name: 'Узбекский сум' },
  { code: 'TJS', symbol: 'сом.',name: 'Таджикский сомони' },
  { code: 'TMT', symbol: 'm',   name: 'Туркменский манат' },

  // СНГ
  { code: 'RUB', symbol: '₽',   name: 'Российский рубль' },
  { code: 'BYN', symbol: 'Br',  name: 'Белорусский рубль' },
  { code: 'UAH', symbol: '₴',   name: 'Украинская гривна' },
  { code: 'AMD', symbol: '֏',   name: 'Армянский драм' },
  { code: 'AZN', symbol: '₼',   name: 'Азербайджанский манат' },
  { code: 'GEL', symbol: '₾',   name: 'Грузинский лари' },
  { code: 'MDL', symbol: 'L',   name: 'Молдавский лей' },

  // Турция и Ближний Восток
  { code: 'TRY', symbol: '₺',   name: 'Турецкая лира' },
  { code: 'AED', symbol: 'د.إ', name: 'Дирхам ОАЭ' },
  { code: 'SAR', symbol: '﷼',   name: 'Саудовский риал' },
  { code: 'IRR', symbol: '﷼',   name: 'Иранский риал' },

  // Универсальные
  { code: 'USD', symbol: '$',   name: 'Доллар США' },
  { code: 'EUR', symbol: '€',   name: 'Евро' },
  { code: 'GBP', symbol: '£',   name: 'Фунт стерлингов' },
  { code: 'CNY', symbol: '¥',   name: 'Китайский юань' },

  // Восточная Азия
  { code: 'JPY', symbol: '¥',   name: 'Японская йена' },
  { code: 'KRW', symbol: '₩',   name: 'Южнокорейская вона' },
  { code: 'INR', symbol: '₹',   name: 'Индийская рупия' },
  { code: 'PKR', symbol: '₨',   name: 'Пакистанская рупия' },
  { code: 'AFN', symbol: '؋',   name: 'Афганский афгани' },

  // Европа (страны вне еврозоны)
  { code: 'PLN', symbol: 'zł',  name: 'Польский злотый' },
  { code: 'CZK', symbol: 'Kč',  name: 'Чешская крона' },
  { code: 'HUF', symbol: 'Ft',  name: 'Венгерский форинт' },
  { code: 'RON', symbol: 'lei', name: 'Румынский лей' },
  { code: 'BGN', symbol: 'лв.', name: 'Болгарский лев' },
  { code: 'CHF', symbol: 'CHF', name: 'Швейцарский франк' },
  { code: 'SEK', symbol: 'kr',  name: 'Шведская крона' },
  { code: 'NOK', symbol: 'kr',  name: 'Норвежская крона' },
  { code: 'DKK', symbol: 'kr',  name: 'Датская крона' },

  // Северная и Латинская Америка
  { code: 'CAD', symbol: 'C$',  name: 'Канадский доллар' },
  { code: 'MXN', symbol: '$',   name: 'Мексиканский песо' },
  { code: 'BRL', symbol: 'R$',  name: 'Бразильский реал' },
  { code: 'ARS', symbol: '$',   name: 'Аргентинский песо' },

  // Тихоокеанский регион
  { code: 'AUD', symbol: 'A$',  name: 'Австралийский доллар' },
  { code: 'NZD', symbol: 'NZ$', name: 'Новозеландский доллар' },
  { code: 'SGD', symbol: 'S$',  name: 'Сингапурский доллар' },
  { code: 'HKD', symbol: 'HK$', name: 'Гонконгский доллар' },
];

// Найти валюту по коду
export function getCurrency(code) {
  return CURRENCIES.find(c => c.code === code)
    || { code: code || 'USD', symbol: code || '$', name: code || 'USD' };
}

// Только символ
export function getCurrencySymbol(code) {
  return getCurrency(code).symbol;
}

// Форматирует число как сумму с валютой:
//   formatMoney(1500.5, 'KGS') → "1 500.50 с"
//   formatMoney(2000, 'KZT')   → "2 000.00 ₸"
//   formatMoney(0, 'USD')      → "0.00 $"
//
// Используем Intl.NumberFormat для разделителей тысяч,
// но без встроенного символа валюты — ставим свой символ из CURRENCIES.
// Это даёт стабильный результат на всех языках интерфейса.
export function formatMoney(amount, currencyCode) {
  const cur = getCurrency(currencyCode || 'KGS');
  const num = Number(amount) || 0;

  // Всегда 2 знака после запятой, разделитель тысяч — пробел
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(num).replace(/,/g, ' '); // вместо запятой используем пробел

  return `${formatted} ${cur.symbol}`;
}

// То же что formatMoney, но без валюты — просто число (для лейблов где валюта рядом отдельно)
export function formatNumber(amount) {
  const num = Number(amount) || 0;
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(num).replace(/,/g, ' ');
}
